module.exports = __webpack_public_path__ + "images/7a74f8fbf89c186e643a78210edb6a6a83cd8d9c5495a15ba072b52455da802c.svg";